import makeStyles from '@material-ui/core/styles/makeStyles';
import { PRIMARY, GRAY_LIGHT } from '@theme_color';

const font = '"Roboto", "Helvetica", "Arial", sans-serif';

const useStyles = makeStyles((theme) => ({
    controlLabel: {
        '& .MuiFormControlLabel-label': {
            fontFamily: font,
            fontSize: 13,
            [theme.breakpoints.down('sm')]: {
                fontSize: 12,
            },
        },
        '&.MuiFormControlLabel-root': {
            marginBottom: 0,
            height: 25,
            '&.Mui-disabled': {
                cursor: 'not-allowed',
            },
        },
        '& .MuiCheckbox-colorSecondary.Mui-checked': {
            color: PRIMARY,
        },
        '& .MuiCheckbox-root': {
            color: GRAY_LIGHT,
            borderRadius: 4,
            padding: '0 11px',
        },
    },
}));

export default useStyles;
